import {Component, Input, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import { Group } from '../../../Models/group';
import { AdminService } from '../../../services/admin.service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {GroupModalComponent} from './group-modal.component';

@Component({
  selector: 'app-groups',
  templateUrl: './group-list.component.html',
  styleUrls: ['./group-list.component.css']
})

export class GroupListComponent implements OnInit {

  groupList: Group[];
  filterText: string;
  onlyEnabled: boolean;
  destComponent: any = GroupModalComponent;
  errorMessage = '';

  constructor(
    private admService: AdminService,
    private modalService: GenericModalService,
    private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.admService.loadGroupList()
      .subscribe(result => this.groupList = result, error => this.errorMessage = error);
  }

  filterData() {
    const emptyFilter = (this.groupList && this.groupList.length === 0) || this.filterText === undefined || this.filterText.trim() === '';
    if (emptyFilter && !this.onlyEnabled) {
      return this.groupList;
    }
    if (emptyFilter && this.onlyEnabled) {
      return this.groupList.filter((v) => {
        return v.enabled;
      });
    }
    if (!emptyFilter && this.onlyEnabled) {
      return this.groupList.filter((v) => {
        return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0 && v.enabled);
      });
    }
    if (!emptyFilter && !this.onlyEnabled) {
      return this.groupList.filter((v) => {
        return (v.name.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0);
      });
    }
  }

  toLiteral(bool: boolean) {
    return (bool ? 'Ativo' : 'Inativo');
  }

  onAddNew() {
    const result$ = this.modalService.showModal(this.destComponent, 'Novo Grupo');
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          this.ngOnInit();
        }
      );
  }

  onEdit(groupId) {
    const result$ = this.modalService.showModal(this.destComponent, 'Editar Grupo', groupId);
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          this.ngOnInit();
        }
      );
  }

}
